import {Component, Input, OnInit} from '@angular/core';
import {FormGroup} from '@angular/forms';
import {TranslateService} from '@ngx-translate/core';

@Component({
  selector: 'app-validation-alert',
  templateUrl: 'validation-alert.component.html'
})
export class ValidationAlertComponent implements OnInit {
  @Input() inputName: string;
  @Input() formGroup: FormGroup;
  private requiredMsg = '';
  private emailMsg = '';
  private patternMsg = '';
  private incorrectWebsiteMsg = '';
  private incorrectUserNameInWebsiteUrlMsg = '';
  private incorrectUserNameMsg = '';
  private postalCodeMsg = '';
  private incorrectReferenceNumberMsg = '';
  private incorrectIdentificatorNumberMsg = '';
  private maxLengthMsg = '';
  private minLengthMsg = '';
  private incorrectDate = '';
  private incorrectTime = '';
  private incorrectDateFormat = '';
  private salaryMsg = '';
  private jobOrderNumberMsg = '';
  private incorrectDictValueMsg = '';
  private dictDoesNotExistMsg = '';
  private maxValueMsg = '';
  private minValueMsg = '';
  private incorrectDecimal = '';
  private incorrectYears = '';
  private incorrectNewPasswordMsg = '';
  private incorectNameMsg = '';
  private incorectHouseNumberFlatNumberMsg = '';
  private incorectStreetNameMsg = '';
  private incorectPhoneNumberMsg = '';
  private incorrectPasswordContainsWhiteSpacesMsg = '';
  private incorrectFromDate = '';
  private incorrectUrl = '';
  private noPhoneOrEmailAddress = '';

  private readonly errorMessages = {
    'required': () => this.requiredMsg,
    'ngbDate': () => this.patternMsg,
    'pattern': () => this.patternMsg,
    'email': () => this.emailMsg,
    'max': (param) => this.maxValueMsg
      .replace('{{max}}', param.max)
      .replace('{{current}}', param.actual),
    'min': (param) => this.minValueMsg
      .replace('{{min}}', param.min)
      .replace('{{current}}', param.actual),
    'maxlength': (param) => this.maxLengthMsg
      .replace('{{max}}', param.requiredLength)
      .replace('{{current}}', param.actualLength),
    'minlength': (param) => this.minLengthMsg
      .replace('{{min}}', param.requiredLength)
      .replace('{{current}}', param.actualLength),
    'incorrectWebsiteUrl': () => this.incorrectWebsiteMsg,
    'incorrectUserNameInWebsiteUrl': () => this.incorrectUserNameInWebsiteUrlMsg,
    'incorrectUserName': () => this.incorrectUserNameMsg,
    'postalCode': () => this.postalCodeMsg,
    'incorrectDate': () => this.incorrectDate,
    'incorrectTime': () => this.incorrectTime,
    'incorrectDateFormat': () => this.incorrectDateFormat,
    'incorrectFromDate': () => this.incorrectFromDate,
    'incorrectReferenceNumber': () => this.incorrectReferenceNumberMsg,
    'incorrectIdentificatorNumber': () => this.incorrectIdentificatorNumberMsg,
    'salary': () => this.salaryMsg,
    'jobOrderNumber': () => this.jobOrderNumberMsg,
    'incorrectDictValue': () => this.incorrectDictValueMsg,
    'dictDoesNotExistMsg': () => this.dictDoesNotExistMsg,
    'incorrectDecimal': () => this.incorrectDecimal,
    'incorrectYears': () => this.incorrectYears,
    'incorrectNewPassword': () => this.incorrectNewPasswordMsg,
    'incorectName': () => this.incorectNameMsg,
    'incorectHouseNumberFlatNumber': () => this.incorectHouseNumberFlatNumberMsg,
    'incorectStreetName': () => this.incorectStreetNameMsg,
    'incorectPhoneNumber': () => this.incorectPhoneNumberMsg,
    'incorrectPasswordContainsWhiteSpaces': () => this.incorrectPasswordContainsWhiteSpacesMsg,
    'incorrectUrl': () => this.incorrectUrl,
    'noPhoneOrEmailAddress': () => this.noPhoneOrEmailAddress
  };

  constructor(private translateService: TranslateService) {
    this.translateService.onLangChange.subscribe(() => {
      this.setupMessages();
    });
  }

  ngOnInit(): void {
    this.setupMessages();
  }

  private setupMessages(): void {
    this.translateService.get('VALIDATION.REQUIRED', {}).subscribe((res: string) => {
      this.requiredMsg = res;
    });
    this.translateService.get('VALIDATION.INCORRECT_PATTERN.DATE', {}).subscribe((res: string) => {
      this.patternMsg = res;
    });
    this.translateService.get('VALIDATION.INCORRECT_PATTERN.EMAIL', {}).subscribe((res: string) => {
      this.emailMsg = res;
    });
    this.translateService.get('VALIDATION.INCORRECT_WEBSITE_URL', {}).subscribe((res: string) => {
      this.incorrectWebsiteMsg = res;
    });
    this.translateService.get('VALIDATION.INCORRECT_USER_NAME_IN_WEBSITE_URL', {}).subscribe((res: string) => {
      this.incorrectUserNameInWebsiteUrlMsg = res;
    });
    this.translateService.get('VALIDATION.INCORRECT_USER_NAME', {}).subscribe((res: string) => {
      this.incorrectUserNameMsg = res;
    });
    this.translateService.get('VALIDATION.INCORRECT_PATTERN.REF_NUMBER', {}).subscribe((res: string) => {
      this.incorrectReferenceNumberMsg = res;
    });
    this.translateService.get('VALIDATION.INCORRECT_PATTERN.ID_NUMBER', {}).subscribe((res: string) => {
      this.incorrectIdentificatorNumberMsg = res;
    });
    this.translateService.get('VALIDATION.INCORRECT_PATTERN.POSTAL_CODE', {}).subscribe((res: string) => {
      this.postalCodeMsg = res;
    });
    this.translateService.get('VALIDATION.MAX_LENGTH', {}).subscribe((res: string) => {
      this.maxLengthMsg = res;
    });
    this.translateService.get('VALIDATION.MIN_LENGTH', {}).subscribe((res: string) => {
      this.minLengthMsg = res;
    });
    this.translateService.get('VALIDATION.INCORRECT_DATE', {}).subscribe((res: string) => {
      this.incorrectDate = res;
    });
    this.translateService.get('VALIDATION.INCORRECT_TIME', {}).subscribe((res: string) => {
      this.incorrectTime = res;
    });
    this.translateService.get('VALIDATION.INCORRECT_DATE_FORMAT', {}).subscribe((res: string) => {
      this.incorrectDateFormat = res;
    });
    this.translateService.get('VALIDATION.INCORRECT_FROM_DATE', {}).subscribe((res: string) => {
      this.incorrectFromDate = res;
    });
    this.translateService.get('VALIDATION.INCORRECT_PATTERN.INCORRECT_SALARY', {}).subscribe((res: string) => {
      this.salaryMsg = res;
    });
    this.translateService.get('VALIDATION.INCORRECT_PATTERN.INCORRECT_JOB_ORDER_NUMBER', {}).subscribe((res: string) => {
      this.jobOrderNumberMsg = res;
    });
    this.translateService.get('VALIDATION.INCORRECT_DICT_VALUE', {}).subscribe((res: string) => {
      this.incorrectDictValueMsg = res;
    });
    this.translateService.get('VALIDATION.DICT_DOES_NOT_EXIST', {}).subscribe((res: string) => {
      this.dictDoesNotExistMsg = res;
    });
    this.translateService.get('VALIDATION.MAX_VALUE', {}).subscribe((res: string) => {
      this.maxValueMsg = res;
    });
    this.translateService.get('VALIDATION.MIN_VALUE', {}).subscribe((res: string) => {
      this.minValueMsg = res;
    });
    this.translateService.get('VALIDATION.INCORRECT_PATTERN.DECIMAL_NUMBER', {}).subscribe((res: string) => {
      this.incorrectDecimal = res;
    });
    this.translateService.get('VALIDATION.INCORRECT_PATTERN.YEARS_NUMBER', {}).subscribe((res: string) => {
      this.incorrectYears = res;
    });
    this.translateService.get('ACCOUNT.DIFFERENT_PASSWORDS', {}).subscribe((res: string) => {
      this.incorrectNewPasswordMsg = res;
    });
    this.translateService.get('VALIDATION.INCORRECT_PATTERN.NAME_LASTNAME', {}).subscribe((res: string) => {
      this.incorectNameMsg = res;
    });
    this.translateService.get('VALIDATION.INCORRECT_PATTERN.HOUSE_NUMBER_FLAT_NUMBER', {}).subscribe((res: string) => {
      this.incorectHouseNumberFlatNumberMsg = res;
    });
    this.translateService.get('VALIDATION.INCORRECT_PATTERN.STREET_NAME', {}).subscribe((res: string) => {
      this.incorectStreetNameMsg = res;
    });
    this.translateService.get('VALIDATION.INCORRECT_PATTERN.PHONE_NUMBER', {}).subscribe((res: string) => {
      this.incorectPhoneNumberMsg = res;
    });
    this.translateService.get('VALIDATION.PASSWORD_CONTAINS_WHITE_SPACES', {}).subscribe((res: string) => {
      this.incorrectPasswordContainsWhiteSpacesMsg = res;
    });
    this.translateService.get('VALIDATION.INCORRECT_PATTERN.URL', {}).subscribe((res: string) => {
      this.incorrectUrl = res;
    });
    this.translateService.get('VALIDATION.EMAIL_OR_PHONE_REQUIRED', {}).subscribe((res: string) => {
      this.noPhoneOrEmailAddress = res;
    });
  }

  shouldShowErrors(): boolean {
    return this.formGroup.controls[this.inputName].errors &&
      (this.formGroup.controls[this.inputName].dirty || this.formGroup.controls[this.inputName].touched);
  }

  listOfErrors(): string[] {
    return Object.keys(this.formGroup.controls[this.inputName].errors || [])
      .map(field => this.getMessage(field, this.formGroup.controls[this.inputName].errors[field]));
  }

  private getMessage(type: string, params: any) {
    return this.errorMessages[type](params);
  }
}



// WEBPACK FOOTER //
// C:/Users/Sylwia/Desktop/12.02/ecv_manager_frontend/src/app/widgets/validation-alert/validation-alert.component.ts